import { environment } from 'src/environments/environment';
import { Component, OnInit } from '@angular/core';
import { BaseComponent } from '../component-base';
import { CurrentUserService } from '../../services/current-user.service';

@Component({
  selector: 'app-side-menu',
  templateUrl: './side-menu.component.html',
  styleUrls: ['./side-menu.component.css']
})
export class SideMenuComponent extends BaseComponent implements OnInit {
  constructor(public override currentUserService: CurrentUserService) {
    super();
  }

  ngOnInit() {
  }
}
